var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwiiterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23.563,
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.2 112H523.8L369.6 288.2L551 528H409L297.7 382.6L170.5 528H99.8L264.7 339.5L90.8 112H236.4L336.9 244.9L453.2 112ZM428.4 485.8H467.5L215.1 152H173.1L428.4 485.8Z",
    fill: "#a6a6a6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiiterGrey);
export default __webpack_public_path__ + "static/media/twiiter-grey.46f65870b14ad6acd6b80e293bf2154e.svg";
export { ForwardRef as ReactComponent };